$ = require 'jquery'

WINDOW_SMALL =
  width: 0
WINDOW_MEDIUM =
  width: 750
WINDOW_LARGE =
  width: 900
WINDOW_EXTRA_LARGE =
  width: 1280

module.exports =
  calc: ->
    @ranCalc = true
    width = $(window).width()

    @fExtraLarge = @fLarge = @fMedium = @fSmall = false

    if width > WINDOW_EXTRA_LARGE.width
      @fExtraLarge = true
    else if width > WINDOW_LARGE.width
      @fLarge = true
    else if width > WINDOW_MEDIUM.width
      @fMedium = true
    else
      @fSmall = true

    $(@).triggerHandler('windowClassChange')

  ensureRun: ->
    if !@ranCalc
      @calc()
